<!-- src/App.vue -->
<template>
  <component :is="layout">
    <RouterView />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from './layouts/DefaultLayout.vue'
import BlankLayout from './layouts/BlankLayout.vue'

const route = useRoute()

const layouts = {
  default: DefaultLayout,
  blank: BlankLayout,
}

// This computed property dynamically selects the layout
// It checks the route's meta field, defaulting to 'default'
const layout = computed(() => {
  const layoutName = route.meta.layout as keyof typeof layouts | undefined
  return layouts[layoutName || 'default']
})
</script>

<style>
/* You can keep your global styles here */
html,
body,
#app {
  height: 100%;
  margin: 0;
  overflow: hidden; /* Be cautious with this, might be better on the layout */
}
</style>
